<div class="global_insets global_background" style="min-height: 80vh">




<div class=spread>
    <div class=stack>
        <label>Start Date</label>
        <h1>{{startDate | date}}</h1>
        <input name="start" type=date placeholder="{{startDate}}" [ngModel]=displayStart (ngModelChange)="setStartDate($event)" />
    </div>
    <h2>{{days}} Days </h2>
    <div class=stack>
        <label>End Date</label>
        <h1>{{endDate | date}}</h1>
        <input name="end" type=date placeholder="End Date" [ngModel]=displayEnd (ngModelChange)="setEndDate($event)" />
    </div>

</div>

<br />
<div  class=spread>
    <button *ngIf="!loading" large mat-raised-button color="primary" (click)="setup()" >Get Results</button>
    <mat-spinner *ngIf="!!loading" [mode]="mode"></mat-spinner>
</div>
    

    

    <table mat-table [dataSource]="orgs" matSort class="mat-elevation-z8 stretch" >
         
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
            <td mat-cell *matCellDef="let org" [ngClass]="{'problem': !org?.active, 'warning': org?.active <= 2, 'good': org?.active > 2}"> {{org?.name}}  </td>
        </ng-container>
        <ng-container matColumnDef="entityId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> EntityId </th>
            <td mat-cell *matCellDef="let org" > {{org?.entityId}}  </td>
        </ng-container>
        <ng-container matColumnDef="active">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Active Users </th>
            <td mat-cell *matCellDef="let org"  [ngClass]="{'problem': !org?.active, 'warning': org?.active <= 2, 'good': org?.active > 2}"> {{org?.active ? org?.active : 0}}  </td>
        </ng-container>
        <ng-container matColumnDef="newUsers">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> New Users </th>
            <td mat-cell *matCellDef="let org" > {{org?.newUsers ? org?.newUsers : 0}}  </td>
        </ng-container>
        <ng-container matColumnDef="instructor">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Instructor Initiated Interaction </th>
            <td mat-cell *matCellDef="let org"> {{org?.instructor ? org?.instructor : 0}} </td>
        </ng-container>
        <ng-container matColumnDef="student">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Student Initiated Interactions </th>
            <td mat-cell *matCellDef="let org"> {{org?.student ? org?.student : 0}}  </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>

